import React from "react";
import line from "../../Images/Vector 13.svg";
import ayan from "../../Images/ayan.png";
import elizabeth from "../../Images/Ellipse 1003.png";
import linkedin from "../../Images/facebook (2).svg";
import twiterr from "../../Images/twitter.svg";
import "./Leadership.css";
const Leadership = () => {
	return (
		<div className="leadership p-4">
			<div className="container mt-5 mb-5">
				<div className="row align-items-center">
					<div className="col-lg-5 col-11 text-lg-start text-center mx-auto">
						<div className="leader-team text-lg-start text-center mb-3">
							The Leadership Team
						</div>
						<div className="leader-deatils mb-4">
							Visual COGS was visualized by leading e-commerce experts and
							thoughtful pioneers aiming to build an efficient, cooperative team
							environment and empower brands and sellers with unmatched,
							collaborative product value.{" "}
						</div>
						<div className="join-team mb-4"> Want to join our team?</div>
						<button className="button ">Explore Opportunities</button>
					</div>
					<div className="col-lg-6 mt-lg-0 mt-5 col-12 mx-auto">
						{/* left  */}
						<div className="ourstory mb-3 d-lg-none align-items-center">
							<div className="ourstory-title text-lg-start text-center ">
								The Founders
							</div>
							<div className="text-center">
								<img src={line} className="text-center" alt="" />
							</div>
						</div>
						<div className="ourstory d-none mb-3 d-lg-flex align-items-center">
							<div className="ourstory-title text-lg-start text-center ">
								The Founders
							</div>
						</div>

						<div className="team-leader-grid mb-5">
							<div className="team-lead-grid-item d-flex flex-column align-items-center justify-content-center">
								<img src={ayan} alt="" className="img-fluid" />
								<div className="team-member-name mt-2 mb-2">M. Aliyan Ali</div>
								<div className="team-deatils-bottom mb-3">
									Creative Director
								</div>
								<div className="icon-team-leader justify-content-center d-flex align-items-center text-center ">
									<img
										src={twiterr}
										className="mx-3"
										width="20px"
										alt=""
										srcset=""
									/>
									<img src={linkedin} className="mx-3" width="20px" alt="" />
								</div>
							</div>
							<div className="team-lead-grid-item d-flex flex-column align-items-center justify-content-center">
								<img src={elizabeth} alt="" className="img-fluid" />
								<div className="team-member-name mt-2 mb-2">John Elizibeth</div>
								<div className="team-deatils-bottom mb-3">
									Creative Director
								</div>
								<div className="icon-team-leader justify-content-center d-flex align-items-center text-center ">
									<img
										src={twiterr}
										className="mx-3"
										width="20px"
										alt=""
										srcset=""
									/>
									<img src={linkedin} className="mx-3" width="20px" alt="" />
								</div>
							</div>
						</div>
						<div className="ourstory mb-3 d-lg-none align-items-center">
							<div className="ourstory-title text-lg-start text-center ">
								Co-Founders
							</div>
							<div className="text-center">
								<img src={line} className="text-center" alt="" />
							</div>
						</div>
						<div className="ourstory d-none mb-3 d-lg-flex align-items-center">
							<div className="ourstory-title text-lg-start text-center ">
								Co-Founders
							</div>
						</div>
						<div className="team-leader-grid1 mb-5">
							<div className="team-lead-grid-item d-flex flex-column align-items-center justify-content-center">
								<img src={ayan} alt="" className="img-fluid" />
								<div className="team-member-name mt-2 mb-2">M. Aliyan Ali</div>
								<div className="team-deatils-bottom mb-3">
									Creative Director
								</div>
								<div className="icon-team-leader justify-content-center d-flex align-items-center text-center ">
									<img
										src={twiterr}
										className="mx-3"
										width="20px"
										alt=""
										srcset=""
									/>
									<img src={linkedin} className="mx-3" width="20px" alt="" />
								</div>
							</div>
							<div className="team-lead-grid-item d-flex flex-column align-items-center justify-content-center">
								<img src={elizabeth} alt="" className="img-fluid" />
								<div className="team-member-name mt-2 mb-2">John Elizibeth</div>
								<div className="team-deatils-bottom mb-3">
									Creative Director
								</div>
								<div className="icon-team-leader justify-content-center d-flex align-items-center text-center ">
									<img
										src={twiterr}
										className="mx-3"
										width="20px"
										alt=""
										srcset=""
									/>
									<img src={linkedin} className="mx-3" width="20px" alt="" />
								</div>
							</div>
							<div className="team-lead-grid-item d-flex flex-column align-items-center justify-content-center">
								<img src={elizabeth} alt="" className="img-fluid" />
								<div className="team-member-name mt-2 mb-2">John Elizibeth</div>
								<div className="team-deatils-bottom mb-3">
									Creative Director
								</div>
								<div className="icon-team-leader justify-content-center d-flex align-items-center text-center ">
									<img
										src={twiterr}
										className="mx-3"
										width="20px"
										alt=""
										srcset=""
									/>
									<img src={linkedin} className="mx-3" width="20px" alt="" />
								</div>
							</div>
						</div>
						<div className="ourstory mb-3 d-lg-none align-items-center">
							<div className="ourstory-title text-lg-start text-center ">
								Head of Depts
							</div>
							<div className="text-center">
								<img src={line} className="text-center" alt="" />
							</div>
						</div>
						<div className="ourstory d-none mb-3 d-lg-flex align-items-center">
							<div className="ourstory-title text-lg-start text-center ">
								Head of Depts
							</div>
						</div>
						<div className="team-leader-grid1 mb-5">
							<div className="team-lead-grid-item d-flex flex-column align-items-center justify-content-center">
								<img src={ayan} alt="" className="img-fluid" />
								<div className="team-member-name mt-2 mb-2">M. Aliyan Ali</div>
								<div className="team-deatils-bottom mb-3">
									Creative Director
								</div>
								<div className="icon-team-leader justify-content-center d-flex align-items-center text-center ">
									<img
										src={twiterr}
										className="mx-3"
										width="20px"
										alt=""
										srcset=""
									/>
									<img src={linkedin} className="mx-3" width="20px" alt="" />
								</div>
							</div>
							<div className="team-lead-grid-item d-flex flex-column align-items-center justify-content-center">
								<img src={elizabeth} alt="" className="img-fluid" />
								<div className="team-member-name mt-2 mb-2">John Elizibeth</div>
								<div className="team-deatils-bottom mb-3">
									Creative Director
								</div>
								<div className="icon-team-leader justify-content-center d-flex align-items-center text-center ">
									<img
										src={twiterr}
										className="mx-3"
										width="20px"
										alt=""
										srcset=""
									/>
									<img src={linkedin} className="mx-3" width="20px" alt="" />
								</div>
							</div>
							<div className="team-lead-grid-item d-flex flex-column align-items-center justify-content-center">
								<img src={elizabeth} alt="" className="img-fluid" />
								<div className="team-member-name mt-2 mb-2">John Elizibeth</div>
								<div className="team-deatils-bottom mb-3">
									Creative Director
								</div>
								<div className="icon-team-leader justify-content-center d-flex align-items-center text-center ">
									<img
										src={twiterr}
										className="mx-3"
										width="20px"
										alt=""
										srcset=""
									/>
									<img src={linkedin} className="mx-3" width="20px" alt="" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Leadership;
